// Catálogo inicial de la tienda (4 artículos de partida).
// Fotos: kit oficial real del club (Umbro, temporada 2025/26), recortadas y
// comprimidas a partir de las fotos de la plantilla. Aún no hay foto propia
// para cada artículo por separado, así que "pantalón 2ª equipación" reutiliza
// la foto del kit de portero (única prenda negra disponible de momento).
export const PRODUCTOS = [
  {
    id: "camiseta-1a",
    nombre: "Camiseta 1ª equipación",
    imagen: "/img/tienda/camiseta-1a-equipacion.webp",
  },
  {
    id: "camiseta-2a",
    nombre: "Camiseta 2ª equipación",
    imagen: "/img/tienda/camiseta-2a-equipacion.webp",
  },
  {
    id: "pantalon-1a",
    nombre: "Pantalón 1ª equipación",
    imagen: "/img/tienda/pantalon-1a-equipacion.webp",
  },
  {
    id: "pantalon-2a",
    nombre: "Pantalón 2ª equipación",
    imagen: "/img/tienda/pantalon-2a-equipacion.webp",
  },
];
